import { render, staticRenderFns } from "./FairPayComingSoonPage.vue?vue&type=template&id=a1b94c3c&scoped=true"
import script from "./FairPayComingSoonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FairPayComingSoonPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FairPayComingSoonPage.vue?vue&type=style&index=0&id=a1b94c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b94c3c",
  null
  
)

export default component.exports